module.exports = __webpack_public_path__ + "files/d677764318ba205b105eba6a3abc7e71.png";